import { jsx as jsx$1, jsxs as jsxs$1 } from '@emotion/react/jsx-runtime';
import { p as parseProps } from '../../dist/parseProps-376f43a7.esm.js';
export { Fragment } from 'react';
import '@theme-ui/css';

var jsx = function jsx(type, props, key) {
  return jsx$1(type, parseProps(props), key);
};
var jsxs = function jsxs(type, props, key) {
  return jsxs$1(type, parseProps(props), key);
};

export { jsx, jsxs };
